import type { Template } from "@/types";

export const LA_03_H2_V1: Template[] = [
{
    id: "la-03-h2v1-01",
    name: "LA 01 - H2V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 164, y: 33, width: 310, height: 409, rotation: 0, imageRotation: 0 },
            { id: "2", x: 785, y: 32, width: 340, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 785, y: 242, width: 340, height: 202, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h2v1-02",
    name: "LA 02 - H2V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 162, y: 39, width: 313, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 676, y: 145, width: 277, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 960, y: 145, width: 277, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h2v1-03",
    name: "LA 03 - H2V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 44, y: 36, width: 313, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 898, y: 36, width: 332, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 898, y: 242, width: 332, height: 198, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h2v1-04",
    name: "LA 04 - H2V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 153, y: 33, width: 332, height: 202, rotation: 0, imageRotation: 0 },
            { id: "2", x: 153, y: 242, width: 332, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 803, y: 33, width: 305, height: 409, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h2v1-05",
    name: "LA 05 - H2V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 38, y: 143, width: 277, height: 194, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 143, width: 277, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 800, y: 39, width: 311, height: 402, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h2v1-06",
    name: "LA 06 - H2V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 74, width: 506, height: 328, rotation: 0, imageRotation: 0 },
            { id: "2", x: 513, y: 74, width: 249, height: 328, rotation: 0, imageRotation: 0 },
            { id: "3", x: 770, y: 74, width: 504, height: 328, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h2v1-07",
    name: "LA 07 - H2V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 60, y: 90, width: 458, height: 297, rotation: 0, imageRotation: 0 },
            { id: "2", x: 525, y: 90, width: 225, height: 297, rotation: 0, imageRotation: 0 },
            { id: "3", x: 758, y: 90, width: 457, height: 297, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h2v1-08",
    name: "LA 08 - H2V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 74, width: 506, height: 328, rotation: 0, imageRotation: 0 },
            { id: "2", x: 513, y: 74, width: 505, height: 328, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1026, y: 74, width: 248, height: 328, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h2v1-09",
    name: "LA 09 - H2V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 60, y: 90, width: 225, height: 297, rotation: 0, imageRotation: 0 },
            { id: "2", x: 292, y: 90, width: 458, height: 297, rotation: 0, imageRotation: 0 },
            { id: "3", x: 758, y: 90, width: 457, height: 297, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h2v1-10",
    name: "LA 10 - H2V1",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 60, y: 90, width: 457, height: 297, rotation: 0, imageRotation: 0 },
            { id: "2", x: 524, y: 90, width: 458, height: 297, rotation: 0, imageRotation: 0 },
            { id: "3", x: 989, y: 90, width: 225, height: 297, rotation: 0, imageRotation: 0 }
    ],
}
];